import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import {
    Avatar,
    Card,
    Image,
    Row,
    Space,
    Typography,
    theme,
    Badge,
    Popover,
    Modal,
    Spin,
    Tooltip,
    Drawer,
} from 'antd'

// assets
import {
    AssignIcon,
    BypassIcon,
    ChangeCostIcon,
    EllipsisIcon,
    MailIcon,
    MobileIcon,
    NonVerifyTalentIcon,
    UnAssignIcon,
    VerifyTalentIcon,
    ViewIcon,
} from '../../assets/icons'

// slices
import {
    getTalentDetails,
    talentListGet,
    talentState,
    updateTalent,
    clearTalentDetail,
    talentDetailGet,
} from './talent.slice'
import { updateUserGet } from '../profile/profile.slice'
import { TALENT_FILTER_STATUS } from '../../constants/general'
import { DOMAIN_LIST } from '../../constants/roles'
import { EditPermissionIcon } from '../../assets/icons/inquiries'
import EditPermission from './talentMenu/EditPermission'

const TalentGrid = ({ props }) => {
    const { Text, Title } = Typography

    const {
        talent,
        modalOpen,
        unAssignModalOpen,
        addRatesModalOpen,
        talentLogin,
        updateStatus,
        talentModalOpen,
        selectedData,
    } = props
    const { useToken } = theme

    const { token } = useToken()

    const { filter, search } = useSelector(talentState)

    const dispatch = useDispatch()

    const [open, setOpen] = useState(false)

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [statusLoading, setStatusLoading] = useState(false)
    const [permissionDrawerOpen, setPermissionDrawerOpen] = useState(false)

    const handleChangeStatus = async () => {
        setStatusLoading(true)
        const payload = {
            updatedData: {
                data: {
                    isActive: selectedUser?.isActive ? false : true,
                },
            },
            _id: selectedUser?._id,
        }
        const result = await dispatch(updateTalent(payload))
        console.log('🚀 ~ handleChangeStatus ~ result:', result)
        if (result?.payload?.data.success) {
            dispatch(
                talentListGet({
                    limit: 10,
                    skip: 0,
                    search: search,
                    filter: { ...filter, status: TALENT_FILTER_STATUS },
                })
            )
            setStatusLoading(false)
            setIsModalOpen(false)
        }
    }

    const handleCancel = () => {
        setIsModalOpen(false)
    }

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen)
    }
    const dropDownIcon = [
        {
            title: <Text>View</Text>,
            icon: <ViewIcon />,
            onClick: () => {
                setOpen(false)
                dispatch(
                    updateUserGet({
                        _id: talent?._id,
                    })
                )
                talentModalOpen()
            },
        },
        talent?.isActive &&
            talent?.phone && {
                title: <Text>Login</Text>,
                icon: <BypassIcon />,
                onClick: () => {
                    talentLogin(talent)
                },
            },
        !talent?.isWorkspaceAssigned && {
            title: (
                <Text
                    style={{
                        color:
                            talent?.isActive && talent?.isOurUser
                                ? token.colorPalette.baseColor.black
                                : token.colorPalette.textColor.senary,
                    }}
                >
                    Workspace Assign
                </Text>
            ),
            icon: (
                <div
                    style={{
                        width: '20px',
                        height: '20px',
                        margin: '0px',
                    }}
                >
                    <AssignIcon
                        color={
                            (!talent?.isActive || !talent?.isOurUser) &&
                            token.colorPalette.textColor.senary
                        }
                    />
                </div>
            ),
            onClick: () => {
                dispatch(getTalentDetails(talent))
                if (
                    talent?.isActive &&
                    talent?.isOurUser &&
                    !talent?.isWorkspaceAssigned
                ) {
                    modalOpen()
                    setOpen(false)
                }
            },
        },
        talent?.isWorkspaceAssigned && {
            title: <Text>Workspace UnAssign</Text>,
            icon: (
                <div
                    style={{
                        width: '20px',
                        height: '20px',
                        margin: '0px',
                    }}
                >
                    <div
                        style={{
                            height: '17px',
                            width: '17px',
                        }}
                    >
                        <UnAssignIcon />
                    </div>
                </div>
            ),
            onClick: () => {
                setOpen(false)
                dispatch(getTalentDetails(talent))
                unAssignModalOpen()
            },
        },
        talent?.isOurUser &&
            !talent?.isWorkspaceAssigned && {
                icon: (
                    <div
                        style={{
                            width: '20px',
                            height: '20px',
                            margin: '0px',
                        }}
                    >
                        <NonVerifyTalentIcon />
                    </div>
                ),
                title: (
                    <Text
                        style={{
                            color: token.colorPalette.baseColor.error,
                        }}
                    >
                        {'Not Verified'}
                    </Text>
                ),
                onClick: () => {
                    updateStatus(talent?._id, talent?.isOurUser)
                },
            },
        !talent?.isOurUser && {
            icon: (
                <div
                    style={{
                        width: '20px',
                        height: '20px',
                        margin: '0px',
                    }}
                >
                    <VerifyTalentIcon />
                </div>
            ),
            title: (
                <Text
                    style={{
                        color: token.colorPalette.iconColor.tertiary,
                    }}
                >
                    {'Verified'}
                </Text>
            ),
            onClick: () => {
                updateStatus(talent?._id, talent?.isOurUser)
            },
        },
        {
            title: <Text>Change Rates</Text>,
            icon: (
                <div
                    style={{
                        width: '20px',
                        height: '20px',
                        margin: '0px',
                    }}
                >
                    <ChangeCostIcon />
                </div>
            ),
            onClick: () => {
                setOpen(false)
                dispatch(getTalentDetails(talent))
                addRatesModalOpen()
            },
        },
        {
            title: (
                <Text
                    style={{
                        color: talent?.isWorkspaceAssigned
                            ? undefined
                            : token.colorPalette.textColor.senary,
                    }}
                >
                    Edit Permissions
                </Text>
            ),
            icon: (
                <div
                    style={{
                        width: '17px',
                        height: '17px',
                        margin: '0px',
                        color: !talent?.isWorkspaceAssigned
                            ? token.colorPalette.textColor.senary
                            : undefined,
                    }}
                >
                    <EditPermissionIcon />
                </div>
            ),
            disabled: !talent?.isWorkspaceAssigned,
            onClick: () => {
                if (talent?.isWorkspaceAssigned) {
                    setOpen(false)
                    setPermissionDrawerOpen(true)
                    dispatch(getTalentDetails(talent))
                    dispatch(talentDetailGet(talent?._id))
                }
            },
        },
    ]

    const onCloseDrawer = () => {
        setPermissionDrawerOpen(false)
        dispatch(clearTalentDetail())
    }

    const dropDownContent = () => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '8px',
                    }}
                >
                    {dropDownIcon?.length > 0 &&
                        dropDownIcon.map((data) => {
                            return (
                                data !== false && (
                                    <Row
                                        style={{
                                            cursor: data?.disabled
                                                ? 'not-allowed'
                                                : 'pointer',
                                        }}
                                        onClick={() => {
                                            if (!data?.disabled) {
                                                data?.onClick(talent?._id)
                                            }
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginRight: '15px',
                                            }}
                                        >
                                            {data?.icon}
                                        </div>
                                        <Text className="sub-title">
                                            {data?.title}
                                        </Text>
                                    </Row>
                                )
                            )
                        })}
                </div>
            </>
        )
    }

    return (
        <div>
            {talent?.isOurUser ? (
                <div
                    style={{
                        position: 'absolute',
                        top: '3px',
                        left: '25px',
                        zIndex: 1,
                    }}
                >
                    <VerifyTalentIcon width="18px" />
                </div>
            ) : (
                <div
                    style={{
                        position: 'absolute',
                        top: '4px',
                        left: '23px',
                        zIndex: 1,
                    }}
                >
                    <NonVerifyTalentIcon width="18px" />
                </div>
            )}
            <Drawer
                placement="right"
                size={'default'}
                style={{
                    height: '100vh',
                    minWidth: '500px',
                    width: '500px',
                }}
                styles={{
                    body: {
                        padding: '0px',
                        display: 'flex',
                        flexDirection: 'column',
                    },
                    wrapper: {
                        width: 'auto !important',
                    },
                }}
                rootClassName="appPermissionDrawer"
                onClose={onCloseDrawer}
                open={permissionDrawerOpen}
                closeIcon={null}
                title={
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 12,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                            }}
                        >
                            {selectedData?.profilePicture ? (
                                <Image
                                    src={selectedData?.profilePicture}
                                    height={36}
                                    className="headerImage"
                                    width={36}
                                    style={{
                                        borderRadius: '50%',
                                        verticalAlign: 'baseline !important',
                                        cursor: 'pointer',
                                    }}
                                    preview={false}
                                />
                            ) : (
                                <Avatar
                                    size={'large'}
                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: 'rgb(0 10 129 / 25%)',
                                    }}
                                >
                                    {selectedData?.name[0].toUpperCase()}
                                    {selectedData?.name.split(' ')[1] !==
                                        undefined &&
                                        selectedData?.name
                                            .split(' ')[1][0]
                                            .toUpperCase()}
                                </Avatar>
                            )}
                            <div>
                                <Title level={5} style={{ margin: 0 }}>
                                    {selectedData?.name}
                                </Title>
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    {selectedData?.email}
                                </Text>
                            </div>
                        </div>
                    </div>
                }
            >
                <EditPermission />
            </Drawer>
            <Card
                style={{
                    cursor: 'auto',
                    borderRadius: '16px',
                    border: 'transparent',
                    boxShadow: '0 0 20px rgba(0,0,0,0.05)',
                    height: '100%',
                }}
                styles={{
                    body: {
                        padding: '22px 20px',
                    },
                }}
            >
                <Row
                    align={'start'}
                    style={{
                        alignItems: 'self-start',
                    }}
                    justify={'space-between'}
                >
                    {talent?.profilePicture ? (
                        <>
                            <Image
                                src={talent?.profilePicture}
                                height={64}
                                width={64}
                                style={{
                                    borderRadius: '50%',
                                    position: 'relative',
                                }}
                                preview={false}
                            />
                            {/* <div
                                style={{
                                    width: '17px',
                                    position: 'absolute',
                                    left: 70,
                                }}
                            >
                                {talent?.isOurUser ? (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-35px',
                                        }}
                                    >
                                        <VerifyTalentIcon />
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-35px',
                                        }}
                                    >
                                        <NonVerifyTalentIcon />
                                    </div>
                                )}
                            </div> */}
                        </>
                    ) : (
                        <>
                            <Avatar
                                style={{
                                    cursor: 'pointer',
                                    position: 'relative',
                                    backgroundColor: 'rgb(0 10 129 / 25%)',
                                }}
                                size={64}
                            >
                                {talent?.name[0].toUpperCase()}
                                {talent?.name.split(' ')[1] !== undefined &&
                                    talent?.name.split(' ')[1] !== '' &&
                                    talent?.name.split(' ')[1][0].toUpperCase()}
                            </Avatar>
                            {/* <div
                                style={{
                                    width: '17px',
                                    position: 'absolute',
                                    left: 70,
                                }}
                            >
                                {talent?.isOurUser ? (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-35px',
                                        }}
                                    >
                                        <VerifyTalentIcon />
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-35px',
                                        }}
                                    >
                                        <NonVerifyTalentIcon />
                                    </div>
                                )}
                            </div> */}
                        </>
                    )}

                    <div style={{ flex: '1', marginLeft: '12px' }}>
                        <Row
                            style={{
                                // marginTop: '10px',
                                columnGap: '6px',
                                flex: '1',
                            }}
                            justify={'space-between'}
                            align={'middle'}
                        >
                            <Title level={5}>{talent?.name}</Title>
                            <Text
                                style={{
                                    color: token.colorPalette.textColor.senary,
                                }}
                            >
                                {talent?.designation?.name}
                            </Text>
                            <Space size={'large'} style={{ columnGap: '10px' }}>
                                <Tooltip
                                    title={
                                        talent?.isActive &&
                                        talent?.workspace?.filter(
                                            (w) =>
                                                !DOMAIN_LIST.includes(w?.domain)
                                        )?.length > 0
                                            ? 'Please unassign workspace before deactivating the user.'
                                            : ''
                                    }
                                >
                                    <Badge
                                        count={
                                            talent?.isActive
                                                ? 'Active'
                                                : 'Inactive'
                                        }
                                        color={
                                            talent?.isActive
                                                ? 'hsla(155, 54%, 46%, 0.16)'
                                                : 'hsla(11, 100%, 59%, 0.16)'
                                        }
                                        onClick={() => {
                                            const assignedWorkspaces =
                                                talent.workspace?.filter(
                                                    (w) =>
                                                        !DOMAIN_LIST.includes(
                                                            w?.domain
                                                        )
                                                )
                                            const hasWorkspace =
                                                assignedWorkspaces?.length > 0
                                            const isBlockDeactivation =
                                                talent.isActive && hasWorkspace

                                            if (isBlockDeactivation) {
                                                return // Prevent modal open, tooltip handles it
                                            }

                                            setSelectedUser(talent)
                                            setIsModalOpen(true)
                                        }}
                                        style={{
                                            minWidth: '30px',
                                            cursor:
                                                talent?.isActive &&
                                                talent?.workspace?.filter(
                                                    (w) =>
                                                        !DOMAIN_LIST.includes(
                                                            w?.domain
                                                        )
                                                )?.length > 0
                                                    ? 'not-allowed'
                                                    : 'pointer',
                                            borderRadius: '6px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: talent?.isActive
                                                ? token.colorPalette.iconColor
                                                      .tertiary
                                                : token.colorPalette.iconColor
                                                      .quaternary,
                                            padding: '12px 8px',
                                            fontWeight: 700,
                                        }}
                                    />
                                </Tooltip>
                                <Popover
                                    content={dropDownContent}
                                    trigger="click"
                                    placement="left"
                                    open={open}
                                    overlayInnerStyle={{
                                        padding: '18px',
                                    }}
                                    arrow={false}
                                    onOpenChange={handleOpenChange}
                                >
                                    <div style={{ cursor: 'pointer' }}>
                                        <EllipsisIcon />
                                    </div>
                                </Popover>
                            </Space>
                        </Row>
                        <Row
                            style={
                                {
                                    // marginTop: '10px',
                                }
                            }
                            align={'middle'}
                        >
                            <Space>
                                <MobileIcon color="#515151" />
                                <Text
                                    style={{
                                        fontSize: '14px',
                                        color: '#515151',
                                    }}
                                >
                                    {talent?.countryCode}
                                    {talent?.phone}
                                </Text>
                            </Space>
                        </Row>
                        <Row
                            style={
                                {
                                    // marginTop: '10px',
                                }
                            }
                            align={'middle'}
                        >
                            <Space>
                                <MailIcon color="#515151" />
                                <Text
                                    style={{
                                        fontSize: '14px',
                                        color: '#515151',
                                    }}
                                >
                                    {talent?.email}
                                </Text>
                            </Space>
                        </Row>
                        <Row style={{ marginTop: '5px' }} align="middle">
                            {talent?.isWorkspaceAssigned &&
                            talent?.workspace?.length > 0 ? (
                                <div
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        backgroundColor: '#F5F5F5',
                                        padding: '4px 10px',
                                        borderRadius: '8px',
                                        gap: '8px',
                                        maxWidth: '100%',
                                        border: `1px solid #6363630d`,
                                        height: '32px', // fixed height helps align things consistently
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '18px',
                                            width: '20px',
                                        }}
                                    >
                                        <Image
                                            src={
                                                talent?.workspace[
                                                    talent?.workspace.length - 1
                                                ]?.logo
                                            }
                                            height={20}
                                            width={20}
                                            preview={false}
                                            style={{
                                                borderRadius: '50%',
                                                objectFit: 'contain',
                                                backgroundColor: '#fff',
                                                display: 'block',
                                            }}
                                            fallback="https://via.placeholder.com/20?text=W"
                                        />
                                    </div>

                                    <Text
                                        style={{
                                            fontSize: '12px',
                                            fontWeight: 500,
                                            color: token.colorText,
                                            whiteSpace: 'nowrap',
                                            lineHeight: 1, // ensures it's centered well
                                        }}
                                        ellipsis
                                    >
                                        {talent?.workspace[
                                            talent?.workspace.length - 1
                                        ]?.companyName ?? 'Unnamed Workspace'}
                                    </Text>
                                </div>
                            ) : (
                                <Text
                                    style={{
                                        // backgroundColor: 'hsla(11, 100%, 59%, 0.08)',
                                        backgroundColor: '#9d9d9d0f',

                                        // color: token.colorPalette.baseColor.error,
                                        color: '#a8a8a8',

                                        padding: '4px 10px',
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        // border: '1px solid #ff38386e',
                                        border: '1px solid #6363630d',

                                        height: '32px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    Unassigned
                                </Text>
                            )}
                        </Row>
                    </div>
                </Row>

                {/* <Row
                style={{
                    marginTop: '10px',
                }}
                align={'middle'}
            >
                {talent?.isWorkspaceAssigned ? (
                    <Row
                        align={'middle'}
                        style={{
                            columnGap: '8px',
                        }}
                    >
                        {talent?.workspace?.length > 0 ? (
                            <Image
                                src={
                                    talent?.workspace[
                                        talent?.workspace?.length - 1
                                    ].logo
                                }
                                height={'25px'}
                                preview={false}
                                width={'25px'}
                                style={{
                                    borderRadius: '50%',
                                    minWidth: '25px',
                                    objectFit: 'contain',
                                }}
                            />
                        ) : (
                            'NA'
                        )}
                        <Text>
                            {
                                talent?.workspace[talent?.workspace?.length - 1]
                                    ?.companyName
                            }
                        </Text>
                    </Row>
                ) : (
                    <Text
                        style={{
                            color: token.colorPalette.baseColor.error,
                        }}
                    >
                        Unassigned
                    </Text>
                )}
            </Row> */}
            </Card>
            <Modal
                // centered

                title={
                    <Row
                        align="middle"
                        justify="start"
                        style={{ columnGap: '10px' }}
                    >
                        <Title
                            level={4}
                            style={{ margin: 0, fontWeight: '700' }}
                        >
                            Change User Status
                        </Title>
                    </Row>
                }
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <button
                        key="cancel"
                        onClick={handleCancel}
                        style={{
                            backgroundColor: 'transparent',
                            border: '1px solid #d9d9d9',
                            padding: '6px 16px',
                            borderRadius: '4px',
                            marginRight: '8px',
                            cursor: 'pointer',
                        }}
                    >
                        Cancel
                    </button>,
                    <button
                        key="confirm"
                        onClick={handleChangeStatus}
                        disabled={statusLoading}
                        style={{
                            backgroundColor: selectedUser?.isActive
                                ? '#ff542e29'
                                : '#36b58029',
                            color: selectedUser?.isActive
                                ? '#b71d18'
                                : '#1b806a',
                            padding: '6px 16px',
                            borderRadius: '4px',
                            border: 'none',
                            cursor: 'pointer',
                            border: '1px solid',
                            borderColor: selectedUser?.isActive
                                ? '#b71d1859'
                                : '#0240024a',
                        }}
                    >
                        {statusLoading && (
                            <Spin style={{ marginRight: '7px' }} size="small" />
                        )}
                        {selectedUser?.isActive ? 'Deactivate' : 'Activate'}
                    </button>,
                ]}
            >
                <p style={{ marginTop: '10px' }}>
                    Are you sure you want to{' '}
                    <b
                        style={{
                            color: selectedUser?.isActive
                                ? '#b71d18'
                                : '#1b806a',
                        }}
                    >
                        {selectedUser?.isActive ? 'deactivate' : 'activate'}
                    </b>{' '}
                    <b>{selectedUser?.name}</b>?
                    {selectedUser?.isActive
                        ? ' They will lose access to the platform.'
                        : ' This will allow them to access the platform.'}
                </p>
            </Modal>
        </div>
    )
}

export default TalentGrid
